// Booststrap - pouze pouzite moduly:
import { Alert, Button, Collapse, Dropdown, Modal, Offcanvas, Popover, Tab } from 'bootstrap';
import { tns } from 'tiny-slider';

import { IWebsite } from '../../../typings/website';
import { MapMapyCz } from './components/map.MapyCz';
import { ServerMap } from './components/mod.servermap';
import { processPageContent } from './components/pageContent';
import { initPhotoSwipeGallery, initPhotoSwipeSingleImage } from './components/photoSwipeGallery';
import { NAVIGATION_ANIMATION_DURATION, SCREEN_WIDTH_TABLET } from './constants';
import { trackCustomEvent } from './helpers/analytics';
import { createCookie, eraseCookie, getCookie, readCookie } from './helpers/cookies';
import { markInvalidControls } from './helpers/forms';
import {
    addClass,
    delay,
    getChildren,
    getClosesParent,
    getRandomString,
    getURLParameter,
    getWindowsHeight,
    hasClass,
    removeClass,
    stripHtml,
} from './helpers/generic';
import { modalBackdropResize } from './helpers/modals';

declare global {
    interface Window {
        __WEBSITE__: IWebsite;
    }
}
const website: IWebsite = window.__WEBSITE__ || {
    App: {},
    AppSettings: {},
    AppStrings: {},
};

website.App = {
    ...website.App,
    Bootstrap: {
        Alert,
        Button,
        //Carousel,
        Collapse,
        Dropdown,
        Modal,
        Offcanvas,
        Popover,
        //ScrollSpy,
        Tab,
        //Toast,
        //Tooltip
    },
    hasClass,
    addClass,
    removeClass,
    getClosesParent,
    getChildren,
    stripHtml,
    getURLParameter,
    getWindowsHeight,
    trackCustomEvent,
    delay,
    createCookie,
    readCookie,
    getCookie,
    eraseCookie,
    getRandomString,
    modalBackdropResize,
    processPageContent,
    // Forms
    markInvalidControls,
    // PhotoSwipe Lightbox
    initPhotoSwipeSingleImage,
    initPhotoSwipeGallery,
    // Sitemap:
    ServerMap,
    // dynamicka mapa:
    MapMapyCz,
    // TinySlider:
    tns,
};

website.AppSettings = {
    ...website.AppSettings,
    SCREEN_WIDTH_TABLET,
    NAVIGATION_ANIMATION_DURATION,
    // calendarSelectedYear: new Date().getFullYear(),
    // calendarSelectedMonth: new Date().getMonth() + 1,
};

window.__WEBSITE__ = website;
